<div class="form-container edp-form request-operation-form d-flex flex-column">
    <form [formGroup]="form">
        <div class="input-container pb-0 d-flex flex-column">
            <!-- DESCRIPTION-->
            <div class="mb-4">
                <label class="text-label mb-2">{{"pt.edp.edponline.transactionsHistory.table.description" | translate}} ({{description.length}}/{{limitChar}})</label>
                <textarea type="text" class="third-step-text-area" formControlName="description" maxlength="300"></textarea>
            </div>

            <!-- CERTIFICACAO ENERGETICA - 02180200 -->
            <div class="ec-wrapper" *ngIf="!!isEnergyCertification">
                <energetic-certification [selectedMotive]="request?.selectedMotive" (submitData)="setData($event)"
                    [argsFileCertification]="argsFileCertification"></energetic-certification>
            </div>

             <!-- CERTIFICACAO ENERGETICA (Certificação Gás + Autodeclaração) - 02180200 -->
             <ng-container *ngIf="!!isGasCertification">
                <energetic-certification-autodeclaration [argsFileGas]="argsFileGas">
                </energetic-certification-autodeclaration>
             </ng-container>

            <!-- TERMINAR CONTRACTO - 02020600 -->
            <div *ngIf="request?.selectedMotive?.externalCategory === '02020600'">
                <end-contract [selectedContract]="selectedContract" (submitData)="setData($event)"></end-contract>
            </div>

            <!-- ELIMINAR CONTA - 02170300 -->
            <div class="mb-4" *ngIf="request?.selectedMotive?.externalCategory === '02170300'">
                <delete-account (submitData)="setData($event)"></delete-account>
            </div>

            <!-- FILES -->
            <ng-container *ngIf="showDefaultFilesUpload">
                <div class="mb-4 d-flex flex-column">
                    <edp-drag-drop-files-upload
                        (uploaded)="onUploadFile($event)"
                        [maxFileSizeMB]="5"
                        [filesMessageLabel]="'pt.edp.edponline.third_step.enable_attach' | translate"
                    ></edp-drag-drop-files-upload>

                    <!-- TARIFA SOCIAL - 02021100 -->
                    <span class="upload-info mt-2" *ngIf="request?.selectedMotive?.externalCategory === '02021100'">
                        {{ 'pt.edp.edponline.third_step.upload_info' | translate}}
                    </span>
                </div>
            </ng-container>

            <div class="d-flex flex-column">
                <re-captcha (resolved)="resolved($event)"></re-captcha>
                <div class="info">
                    <span class="verify"
                    [innerHTML]="'pt.edp.edponline.requests-and-operations.creation.recaptcha.validation-label-1' | translate"></span>
                    <span class="mandatory mt-2"
                    [innerHTML]="'pt.edp.edponline.requests-and-operations.creation.recaptcha.validation-label-2' | translate"></span>
                </div>
            </div>
        </div>
    </form>

    <div class="d-flex flex-row footer">
        <a class="btn-previous d-block d-wdgt-none" (click)="backStep()" [gaClickDatalayer]="'requestsNewModalBack'">
            <span><i class="sidebar-footer-icon icon-edponline-Bop-073 rotate-90" aria-hidden="true"></i></span>
            <span class="ml-2 sidebar-footer-text">
                {{ 'pt.edp.edponline.resquests-and-operations.previous' | translate }}</span>
        </a>

        <button class="btn btn-primary" [disabled]="!form.valid" (click)="submit()">
            {{ (!btnText
                ? "pt.edp.edponline.resquests-and-operations.advance"
                : "pt.edp.edponline.requests.operations.help.submit") | translate }}
        </button>
    </div>
</div>
